import {
  REQUEST_USER_DETAILS,
  SUCCESS_USER_DETAILS,
  SUCCESS_USER_REMOVE,
  REQUEST_USER_ADD,
  SUCCESS_USER_ADD,
  SUCCESS_USER_BYID,
  SUCCESS_USER_EDIT,
  REQUEST_ALL_USER_DETAILS,
  SUCCESS_ALL_USER_DETAILS,
  REQUEST_ATTENDANCE_GET,
  SUCCESS_ATTENDANCE_ADD,
  REQUEST_ATTENDANCE_ADD,
  SUCCESS_ATTENDANCE_GET,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  users: null,
  total: null,
  attendancedata: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case REQUEST_USER_DETAILS: {
      return {
        ...state,
        loader: true,
      };
    }
    case SUCCESS_USER_DETAILS: {
      return {
        ...state,
        loader: false,
        users: action.payload,
        total: action.payload.total,
      };
    }
    case REQUEST_ATTENDANCE_GET: {
      return {
        ...state,
        loader: true,
      };
    }
    case SUCCESS_ATTENDANCE_GET: {
      return {
        ...state,
        loader: false,
        attendancedata: action.payload,
      };
    }
    case REQUEST_ALL_USER_DETAILS: {
      return {
        ...state,
        loader: true,
      };
    }
    case SUCCESS_ALL_USER_DETAILS: {
      return {
        ...state,
        loader: false,
        users: action.payload,
      };
    }
    case SUCCESS_USER_REMOVE: {
      return {
        ...state,
        loader: false,
      };
    }
    case SUCCESS_USER_BYID: {
      return {
        ...state,
        loader: false,
        editedRestaurant: action.payload,
      };
    }
    case REQUEST_USER_ADD: {
      return {
        ...state,
        loader: true,
      };
    }
    case SUCCESS_USER_ADD: {
      return {
        ...state,
        loader: false,
      };
    }
    case REQUEST_ATTENDANCE_ADD: {
      return {
        ...state,
        loader: true,
      };
    }
    case SUCCESS_ATTENDANCE_ADD: {
      return {
        ...state,
        loader: false,
      };
    }
    case SUCCESS_USER_EDIT: {
      return {
        ...state,
        loader: false,
      };
    }
    default:
      return state;
  }
};
